import { render } from "./HorariosView.vue?vue&type=template&id=4923fd51&scoped=true"
import script from "./HorariosView.vue?vue&type=script&lang=js"
export * from "./HorariosView.vue?vue&type=script&lang=js"

import "./HorariosView.vue?vue&type=style&index=0&id=4923fd51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4923fd51"]])

export default __exports__